module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "platform"
    }
  }, [(_vm.roletype === 'core') ? _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_c('span', [_vm._v("平台产品")]), _vm._v(" "), _c('strong', {
    class: _vm.coreProduct === 'operator' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.coreProduct = 'operator'
      }
    }
  }, [_vm._v("核心端操作平台")]), _vm._v(" "), _c('strong', {
    class: _vm.coreProduct === 'tool' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.coreProduct = 'tool'
      }
    }
  }, [_vm._v("智能诊断工具")]), _vm._v(" "), _c('strong', {
    class: _vm.coreProduct === 'product' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.coreProduct = 'product'
      }
    }
  }, [_vm._v("数据风控产品")])]), _vm._v(" "), (_vm.coreProduct === 'operator') ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx1_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx1_2@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : (_vm.coreProduct === 'tool') ? [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2_3@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : (_vm.coreProduct === 'product') ? [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3_3@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : _vm._e()], 2)]) : (_vm.roletype === 'institution') ? _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "margin-right": "650px"
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('strong', {
    class: _vm.institutionProduct === 'products' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.institutionProduct = 'products'
      }
    }
  }, [_vm._v("数据风控产品")]), _vm._v(" "), _c('strong', {
    class: _vm.institutionProduct === 'platform' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.institutionProduct = 'platform'
      }
    }
  }, [_vm._v("机构端操作平台")])]), _vm._v(" "), (_vm.institutionProduct === 'products') ? [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg1_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "288px",
      "margin-top": "30px"
    },
    attrs: {
      "src": "/imgs/portal/products/jg1_2@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : (_vm.institutionProduct === 'platform') ? [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2_3@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : _vm._e()], 2)]) : (_vm.roletype === 'chain') ? _c('header', [_c('div', {
    staticClass: "cover"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1_2@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("立即体验")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "product",
      "roleType": _vm.roletype
    }
  }), _vm._v(" "), _vm._m(7)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-home",
      "roleType": _vm.roletype
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("核心企业")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用后台企业预设、用户通过手机号注册登录")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("业务批量上线；轻松统筹上下游；资金流向一目了然")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("核心企业")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用后台企业预设、用户通过手机号注册登录")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("快速了解核心企业基本信息；供应链融资需求诊断；自动化生成推荐方案；方案效果智能可视化；定制化群星方案报告")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("核心企业")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用后台企业预设、用户通过手机号注册登录")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("助缩短项目分析周期；加速资产分析批量化；成为Woodpecker和群星平台的接力站")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("金融机构")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用手机号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("充分利用机器学习；动态追踪，实时观测风险，预防欺诈；精准区分出风险的高低")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("金融机构")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用手机号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("风险实时监控；风险可视化；操作便捷")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticStyle: {
      "margin-right": "770px"
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('strong', [_vm._v("链属端操作平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("供应商／经销商")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用手机号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("多终端覆盖；账户体系，款票货一致；操作便捷，一键收款")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-660fae62"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/products/Platform.vue
// module id = 1346
// module chunks = 26